<template>
  <div id="MOBEC">
    <div id="MOBEC-top">
      <div class="MOBEC-top-content">
        <h1>身体活动检测仪</h1>
        <p class="MOBEC-top-p1">WGT3X-BT是ActiGraph的旗舰活动检测仪，被世界各地的研究人员广泛用来捕获和记录身体活动和睡眠信息。</p>
        <div class="MOBEC-top-content-detail">
          <p class="left">尺寸：4.6cm x 3.3cm x 1.5cm<br>重量：19克<br>采样率：30-100赫兹<br>动态范围：+/- 8G<br>电池：25天<br>内存：4G</p>
          <p class="right">数据储存：180天<br>配带位置：手腕，腰部，脚踝，大腿<br>传输方式：USB，蓝牙<br>耐水性：1米内30分钟<br>保修期：1年</p>
        </div>
        <p class="MOBEC-top-p2">作为世界上应用最广泛的研究级身体活动加速度计检测仪器，ActiGraph已经先后与美国国家卫生与营养考试调查（NHANES），西澳大利亚妊娠队列研究（Raine）研究，妇女健康研究和NAKO德国全国队列等机构合作。</p>
      </div>
      <img src="../../assets/images/ProductAndService/MOBEC/top-img.png"/>
    </div>
    <div id="MOBEC-middle">
      <img class="middle-img" src="../../assets/images/ProductAndService/MOBEC/middle-img.png"/>
      <div class="MOBEC-middle-content">
        <h1>睡眠能耗监测仪</h1>
        <p class="MOBEC-middle-content-p1"> AMI的各种型号的Motionlogger提供产品中包括基本的睡眠质量评估，高分辨率模拟数据采集，同步环境数据采集和睡眠分布数据。</p>
        <div class="MOBEC-middle-content-detail">
          <p class="left">重量：30g<br>电池：纽扣电池<br>电池使用时间：30天<br>内存容量：2M<br>取样率：28～35Hz</p>
          <p class="right">加速度灵敏度：0.01G<br>是否支持检测手表被取下：支持<br>记录模式：ZCM和PIM<br>数据导出：原始数据，夜醒次数，睡眠节律，最长睡眠时间</p>
        </div>
        <img class="middle-img-bg" src="../../assets/images/ProductAndService/MOBEC/middle-img-bg.png"/>
      </div>
    </div>
    <div id="MOBEC-end">
      <div class="triangle"></div>
      <div class="MOBEC-end-content">
        <div class="left">
          <h1>AW2 软件 ：</h1>
          <p>建立针对佩戴者个人的数据库，标明夜间在床时间/主要在床时间、其他在床时间、睡眠时长、活动时长平均数、总清醒时间、睡眠潜伏期、睡眠片段化指数等参数。</p>
        </div><!--
     --><div class="right">
          <h1>Action4软件：</h1>
          <p>提供各样的分析算法，包括：汇总统计分析和分布式分析，自相关Auto-correlation (R24)和互相关分析Cross-Correlation，波形分析Waveform：Cosinor、Harmonic Fit、MESA、Fourier、Averaged Waveform、Nonparametric Circadian Rhythm Analysis (IS, IV, RA)</p>
        </div>
        <p class="summarize">已有的合作方有美国NASA、医疗中心、制药公司、美国国防部、研究所等，针对睡眠研究、疼痛科、老年医学与临床研究、护理研究、工作负荷监测、药物研究、注意缺陷多动障碍、动物监测、环境监测、精神科、运动医学等领域的研究合作均已到达成熟。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#MOBEC-top{
  height: 700px;
  white-space:nowrap;
}
#MOBEC-top .MOBEC-top-content{
  margin: 0 auto;
  width: 1080px;
  display: inline-block;
  padding-top: 84px;
}
#MOBEC-top .MOBEC-top-content h1{
  text-align: left;
  font-size: 30px;
  color: #282828;
  margin-left: 53px;
  font-weight: normal;
}
#MOBEC-top .MOBEC-top-content .MOBEC-top-p1{
  width: 378px;
  margin-left: 53px;
  margin-top: 20px;
  text-align: left;
  line-height: 30px;
  font-size: 16px;
  color: #282828;
  white-space:normal;
}
#MOBEC-top .MOBEC-top-content .MOBEC-top-content-detail{
  width: 570px;
  margin-left: 50px;
  margin-top: 18px;
  padding-top: 14px;
  padding-bottom: 22px;
  text-align: left;
  font-size: 15px;
  line-height: 30px;
  color: #282828;
  background-color: #faddde;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
}
#MOBEC-top .MOBEC-top-content .MOBEC-top-content-detail .left{
  margin-left: 35px;
  width: 210px;
  display: inline-block;
  vertical-align:text-top;
  white-space:normal;
}
#MOBEC-top .MOBEC-top-content .MOBEC-top-content-detail .right{
  margin-left: 35px;
  display: inline-block;
  vertical-align:text-top;
  white-space:normal;
}
#MOBEC-top .MOBEC-top-content .MOBEC-top-p2{
  width: 548px;
  text-indent:2em;
  margin-top: 42px;
  margin-left: 53px;
  text-align: left;
  line-height: 30px;
  font-size: 16px;
  white-space:normal;
  color: #282828;
}
#MOBEC-top img{
  display: inline;
  margin-left: -460px;
  margin-top: 106px;
  position: absolute;
  z-index: -1;
}

#MOBEC-middle{
  height: 700px;
  background-color: #ddd8cf;
}
#MOBEC-middle .MOBEC-middle-content{
  margin: 0 auto;
  display: inline-block;
  width: 1080px;
}
#MOBEC-middle .middle-img{
  margin-left: -134px;
  margin-top: 138px;
  display: inline;
  position: absolute;
}

#MOBEC-middle .middle-img-bg{
  display: inline;
  margin-top: -364px;
  margin-left: 316px;
  position: absolute;
}
#MOBEC-middle .MOBEC-middle-content h1{
  text-align: left;
  font-size: 30px;
  color: #282828;
  margin-left: 500px;
  padding-top: 170px;
  font-weight: normal;
}
#MOBEC-middle .MOBEC-middle-content .MOBEC-middle-content-p1{
  font-size: 16px;
  text-align: left;
  position: absolute;
  line-height: 30px;
  margin-left: 500px;
  margin-top: 20px;
  color: #282828;
  z-index:999;
  width: 387px;
}
#MOBEC-middle .MOBEC-middle-content .MOBEC-middle-content-detail{
  margin-top: 138px;
  margin-left: 481px;
  width: 542px;
  background-color: #eeece7;
  text-align: left;
  font-size: 14px;
  padding-top:30px;
  padding-bottom: 30px;
  line-height: 30px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  color: #282828;
}
#MOBEC-middle .MOBEC-middle-content .MOBEC-middle-content-detail .left{
  margin-left: 53px;
  width: 212px;
  display: inline-block;
  vertical-align:text-top;
}
#MOBEC-middle .MOBEC-middle-content .MOBEC-middle-content-detail .right{
  margin-left: 20px;
  width: 238px;
  display: inline-block;
  vertical-align:text-top;
}
#MOBEC-end .triangle{
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 35px;
  border-style: solid;
  border-color: #ddd8cf transparent transparent transparent;
}
#MOBEC-end .MOBEC-end-content{
  width: 1080px;
  margin: 0 auto;
  margin-top: 13px;
}
#MOBEC-end .MOBEC-end-content .left{
  width: 354px;
  height: 198px;
  border:2px solid black;
  border-style: dashed;
  border-radius:20px;
  display: inline-block;
  vertical-align:text-top;
}
#MOBEC-end .MOBEC-end-content .right{
  width: 659px;
  height: 198px;
  margin-left: 57px;
  border:2px solid black;
  border-style: dashed;
  border-radius:20px;
  display: inline-block;
  vertical-align:text-top;
}
#MOBEC-end .MOBEC-end-content .summarize{
  text-align: left;
  color: #282828;
  font-size: 16px;
  line-height: 26px;
  text-indent:2em;
  margin-top: 38px;
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 38px;
}
#MOBEC-end .MOBEC-end-content .left h1{
  margin-top: 30px;
  margin-left: 23px;
  font-size: 16px;
  line-height: 30px;
  color: #282828;
  text-align: left;
}
#MOBEC-end .MOBEC-end-content .left p{
  margin-left: 23px;
  margin-right: 20px;
  font-size: 16px;
  line-height: 30px;
  color: #282828;
  text-align: left;
  text-indent:2em;
}
#MOBEC-end .MOBEC-end-content .right h1{
  margin-top: 30px;
  margin-left: 23px;
  font-size: 16px;
  line-height: 30px;
  color: #282828;
  text-align: left;
}
#MOBEC-end .MOBEC-end-content .right p{
  margin-left: 23px;
  margin-right: 20px;
  font-size: 16px;
  line-height: 30px;
  color: #282828;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductAndService/MOBEC.vue